import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { Link } from '@design-system/link';
import { ScreenReadersContent } from '@design-system/screen-readers-content';
import { isEqual } from 'lodash';
import { memo } from 'react';
import { styled } from 'styled-components';
import { Slider } from '../Slider';
const SliderMemoised = memo((_a) => {
    var otherProps = __rest(_a, []);
    return _jsx(Slider, Object.assign({}, otherProps));
}, (prevProps, nextProps) => isEqual(prevProps.items, nextProps.items));
export const SliderWithTitle = (_a) => {
    var _b;
    var { link, title, titleAs = 'div', titleFont = 'h3-semibold' } = _a, otherProps = __rest(_a, ["link", "title", "titleAs", "titleFont"]);
    const { total = null } = otherProps;
    return (_jsxs(Wrapper, { children: [title && (_jsxs(StyledBox, { children: [_jsx(Box, { as: titleAs, font: titleFont, children: total === null ? title : `${title} (${total})` }), link && (_jsxs(LinkStyled, { target: link.target, to: (_b = link.url) !== null && _b !== void 0 ? _b : '', children: [link.text, _jsx(ScreenReadersContent, { children: link.accessibilityDescription })] }))] })), _jsx(SliderMemoised, Object.assign({}, otherProps))] }));
};
const Wrapper = styled(Box).attrs(() => ({
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
})) `
  & .slider-container {
    width: 100%;
  }
`;
const StyledBox = styled(Box).attrs(() => ({
    alignItems: 'center',
    justifyContent: 'space-between',
    pb: 4,
    width: '100%',
})) `
  padding-bottom: 14px;
`;
const LinkStyled = styled(Link).attrs(() => ({
    font: 'h4-semibold',
})) ``;
//# sourceMappingURL=SliderWithTitle.js.map